import React from 'react';
import { Grid, Row, Col, Panel, FormGroup, Checkbox, Button, Radio, Table} from 'react-bootstrap';
import { handleHttpResponse } from '../../lib/Helpers';
import DateHelpers from '../../lib/DateHelpers'

class UserConversationTable extends React.Component {
  render() {
    return(
      <Table striped bordered condensed>
        <thead>
          <tr>
            <td><b>Other Participant</b></td>
            <td><b>Most Recent Messages</b></td>
            <td><b>Date Sent</b></td>
          </tr>
        </thead>
        <tbody>
          {
            this.props.conversations.map((conversation, conversation_index)=>{
              const first_message = conversation.messages[0];
              const other_participant = conversation.participants.filter(
                participant =>
              participant.swipecast_user_id !=this.props.user.swipecast_user_id
              )[0];
              return(
                <tr key={'conversation'+conversation_index}>
                  <td>
                    {`${other_participant.first_name} ${other_participant.last_name}`}
                  </td>
                  <td style={{whiteSpace:'pre-wrap'}}>
                    {conversation.messages.reverse().map((message,message_index)=>{
                      if (message_index==conversation.messages.length-1)
                      {
                        return (
                          <p>
                            <b>{`[Most recent] ${message.first_name}: `}</b>
                            {`${message.message}\n\n`}
                          </p>
                        );
                      }
                      else
                      {
                        return (<p>
                          <b>{`${message.first_name}: `}</b>
                          {`${message.message}\n\n`}
                          </p>
                        );
                      }
                    })
                  }
                  </td>
                  <td>
                    {DateHelpers.timeStampToLabel(first_message.created_at, true)}
                  </td>
                </tr>
              )
            })
          }
        </tbody>
      </Table>
    )
  }
}

export default UserConversationTable;
